import { CopaTokenResponse } from 'src/types/auth'
import { readAccessToken } from '../../constants/storageKeys'
import { client } from '../axios'

// Renewed early so a long COPA answer still holds a live token when COPA calls the MCP near its end.
const RENEW_BEFORE_MS = 10 * 60 * 1000

interface CachedToken {
  platformToken: string | null
  value: string
  expiresAt: number
}

let cached: CachedToken | null = null
let pending: { platformToken: string | null; promise: Promise<string> } | null = null

// Keyed by the platform token: sign-out is an in-app navigation, so the next user would otherwise inherit this one.
const isFresh = (token: CachedToken | null, platformToken: string | null): token is CachedToken =>
  token?.platformToken === platformToken && token.expiresAt - Date.now() > RENEW_BEFORE_MS

export const getCopaUserToken = (): Promise<string> => {
  const platformToken = readAccessToken()
  if (isFresh(cached, platformToken)) {
    return Promise.resolve(cached.value)
  }

  if (pending?.platformToken !== platformToken) {
    const promise = client
      .post<CopaTokenResponse>('/tokens/copa')
      .then(({ data }) => {
        cached = { platformToken, value: data.access_token, expiresAt: Date.now() + data.expires_in * 1000 }
        return data.access_token
      })
      .finally(() => {
        if (pending?.promise === promise) pending = null
      })
    pending = { platformToken, promise }
  }
  return pending.promise
}
